export default "__VITE_ASSET__B8jHanX2__"